function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.96 3.0614L6.76 4.85958L5.34 6.27601L3.55 4.47784L4.96 3.0614ZM1 10.5454H4V12.5546H1V10.5454ZM11 0.549988H13V3.51346H11V0.549988ZM19.04 3.0614L20.45 4.47784L18.66 6.27601L17.25 4.85958L19.04 3.0614ZM23 12.5546H20V10.5454H23V12.5546ZM6 11.55C6 8.22487 8.69 5.52259 12 5.52259C15.31 5.52259 18 8.22487 18 11.55C18 12.0497 17.9392 12.5354 17.8247 13H6.17527C6.06077 12.5354 6 12.0497 6 11.55Z",
  fill: "#F2C94C"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: 13,
  width: 25,
  height: 1,
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgMdiWbMorning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiWbMorning);
export default __webpack_public_path__ + "static/media/mdi_wb_morning.462a8c04.svg";
export { ForwardRef as ReactComponent };